export default "__VITE_ASSET__B4yDYYMs__"